import React, { useState, useEffect } from 'react';
import { useParams } from "react-router-dom";
import { useDispatch, useSelector, shallowEqual } from "react-redux";
import { getChallenge, updateParticipantScore } from '../../actions/adminActions';
import { showScore } from '../../utils/translate';
import { PayoutType, GameType } from '../../utils/const';
import Moment from 'react-moment';
import 'moment-timezone';

import { forwardRef } from 'react';
import MaterialTable from "material-table";
import Grid from '@material-ui/core/Grid'
import AddBox from '@material-ui/icons/AddBox';
import ArrowDownward from '@material-ui/icons/ArrowDownward';
import Check from '@material-ui/icons/Check';
import ChevronLeft from '@material-ui/icons/ChevronLeft';
import ChevronRight from '@material-ui/icons/ChevronRight';
import Clear from '@material-ui/icons/Clear';
import DeleteOutline from '@material-ui/icons/DeleteOutline';
import Edit from '@material-ui/icons/Edit';
import FilterList from '@material-ui/icons/FilterList';
import FirstPage from '@material-ui/icons/FirstPage';
import LastPage from '@material-ui/icons/LastPage';
import Remove from '@material-ui/icons/Remove';
import SaveAlt from '@material-ui/icons/SaveAlt';
import Search from '@material-ui/icons/Search';
import ViewColumn from '@material-ui/icons/ViewColumn';
import { alpha } from '@material-ui/core/styles';
import { Checkbox, Switch, TextField } from '@material-ui/core';
import Alert from '@material-ui/lab/Alert';
import './materialTable.css'


const tableIcons = {
	Add: forwardRef((props, ref) => <AddBox {...props} ref={ref} />),
	Check: forwardRef((props, ref) => <Check {...props} ref={ref} />),
	Clear: forwardRef((props, ref) => <Clear {...props} ref={ref} />),
	Delete: forwardRef((props, ref) => <DeleteOutline {...props} ref={ref} />),
	DetailPanel: forwardRef((props, ref) => <ChevronRight {...props} ref={ref} />),
	Edit: forwardRef((props, ref) => <Edit {...props} ref={ref} />),
	Export: forwardRef((props, ref) => <SaveAlt {...props} ref={ref} />),
	Filter: forwardRef((props, ref) => <FilterList {...props} ref={ref} />),
	FirstPage: forwardRef((props, ref) => <FirstPage {...props} ref={ref} />),
	LastPage: forwardRef((props, ref) => <LastPage {...props} ref={ref} />),
	NextPage: forwardRef((props, ref) => <ChevronRight {...props} ref={ref} />),
	PreviousPage: forwardRef((props, ref) => <ChevronLeft {...props} ref={ref} />),
	ResetSearch: forwardRef((props, ref) => <Clear {...props} ref={ref} />),
	Search: forwardRef((props, ref) => <Search {...props} ref={ref} />),
	SortArrow: forwardRef((props, ref) => <ArrowDownward {...props} ref={ref} />),
	ThirdStateCheck: forwardRef((props, ref) => <Remove {...props} ref={ref} />),
	ViewColumn: forwardRef((props, ref) => <ViewColumn {...props} ref={ref} />)
};


export const Challenge = () => {
    let params = useParams();
	const dispatch = useDispatch();

	var columns = [{ title: "id", field: "id", hidden: true },
		{
			title: "Placement", render: rowData => showMedalOrIndex({ index: rowData.tableData.id, placement: rowData.placement, payout: rowData.payout, error: rowData.error, challengeError: challenge.error }),
		},
		{
			title: "Name", render: rowData => showImageAndName({ participant: rowData })
		},
		{
			title: "Score", field: "score", render: rowData => showScoreAndPayout({ participant: rowData }), editable: 'onUpdate',
			editComponent: props => {
				if (challenge.gameType === GameType.STROKE_PLAY || challenge.gameType === GameType.STROKE_PLAY) {
					return (
						<input
							id="strokes"
							type="text"
							value={props.rowData.strokes}
							onChange={e =>
								props.onRowDataChange({
									...props.rowData,
									strokes: e.target.value
								})
							}
						/>
					)
				}
				else {
					return (
						<input
							id="points"
							type="text"
							value={props.rowData.points}
							onChange={e =>
								props.onRowDataChange({
									...props.rowData,
									points: e.target.value
								})
							}
						/>
					)
                }
			}
		},
		{ title: "Error", field: "errorDescription", editable: 'never',}
		]

	const { challenge, remoteHasError, remoteErrorMessages } = useSelector(state => ({
		challenge: state.adminReducer.challenge,
		remoteHasError: state.adminReducer.isError,
		remoteErrorMessages: state.adminReducer.errorMessages
	}), shallowEqual);


	const [isError, setIsError] = useState(remoteHasError)
	const [errorMessages, setErrorMessages] = useState(remoteErrorMessages)

    useEffect(() => {
        dispatch(getChallenge(params.challengeId));
	}, ['All']);

	useEffect(() => {
		setIsError(remoteHasError);
	}, [remoteHasError]);

	useEffect(() => {
		setErrorMessages(remoteErrorMessages);
	}, [remoteErrorMessages]);

	const handleRowUpdate = (newData, oldData, resolve) => {
		
		let errorList = [];
		if (challenge.gameType === GameType.STROKE_PLAY || challenge.gameType === GameType.STROKE_PLAY) {
			if (newData.strokes === undefined || newData.strokes === "-" || newData.strokes === "0") {
				newData.strokes = undefined;
            }
			else if (isNaN(newData.strokes)) {
				errorList.push(newData.strokes + " is not a valid number")
			}
		}
		else {
			if (newData.points === undefined || newData.points === "-" || newData.points === "0") {
				newData.points = undefined;
			}
			else if (isNaN(newData.points)) {
				errorList.push(newData.points + " is not a valid number")
			}
        }


		if (errorList.length < 1) {
			if (challenge.gameType === GameType.STROKE_PLAY || challenge.gameType === GameType.STROKE_PLAY) {
				dispatch(updateParticipantScore(challenge.id, newData.userId, newData.strokes));
			}
			else {
				dispatch(updateParticipantScore(challenge.id, newData.userId, newData.points));
            }
		}
		else {
			setErrorMessages(errorList)
			setIsError(true)
		}
		resolve();
	}

    if (challenge == null) {
		return (<div><h2 className="panel-title">Loading...</h2></div>);
    }

	return (
		<>
		<div className="container-fluid">
			<div className="row">
				<div className="col-xl-6">
					<h2 className="panel-title">{challenge.name}</h2>
					<div className="">
						<div className="lobby-head">
							<div className="challenge-starttime"><span className="challenge-time-label">Start time:</span> <Moment format="YYYY-MM-DD HH:mm">{challenge.startTime}</Moment></div>
							<div className="challenge-endtime"><span className="challenge-time-label">End time:</span> <Moment format="YYYY-MM-DD HH:mm">{challenge.endTime}</Moment></div>
						</div>
					</div>
					<div className="">
						<p>{challenge.error ? challenge.errorDescription : 'No issues!'}</p>
					</div>
				</div>
			</div>
			<div className="row">
				<div className="col-xl-12">
					<Grid container spacing={1}>

						<Grid item xs={12}>
							<div>
								{isError &&
									<Alert severity="error">
										{errorMessages.map((msg, i) => {
											return <div key={i}>{msg}</div>
										})}
									</Alert>
								}
							</div>
							<MaterialTable
								title="Challenges"
								columns={columns}
								data={challenge.participants}
								icons={tableIcons}
								options={{
									pageSize: 15,
									pageSizeOptions: [15, 50],
									toolbar: true,
									paging: false,
									search: false,
								}}
								editable={{
									onRowUpdate: (newData, oldData) =>
										new Promise((resolve) => {
											handleRowUpdate(newData, oldData, resolve);
										}),

								}}
							/>
						</Grid>
						<Grid item xs={3}></Grid>
					</Grid>
				</div>
				
			</div> 
			{/** 
			<div className="row">
				<div className="col-xl-6">
					<h2 className="panel-title">Challenge data - #{challenge.id}</h2>
					<div className="panel">
						<div className="container-fluid">
							<table className="table lobby-table table-hover table-striped">
								<tbody>
									{challenge.participants.map((participant, index) => (
										<tr key={participant.userId}>
											<td className="count">
												{showMedalOrIndex({ index, placement: participant.placement, payout: participant.payout, error: participant.error, challengeError: challenge.error })}
											</td>
											<td className="challenger">
												{showImageAndName({ participant: participant })}
											</td>																			
											<td className="stats">
												{showScoreAndPayout({participant: participant })}
											</td>
										</tr>	
									))}
								</tbody>
							</table>
						</div>
					</div>
				</div>
				
			</div> **/}
		</div>
		<div><br/><br/></div>
		</>
    );
}

const showMedalOrIndex = ({ index,  placement, payout, error, challengeError }) => {


	if (typeof payout !== 'undefined' && payout !== null && !error) {
		//Since we have payout and no error challenge is done
		if (placement === 1) {
			return <img className="medal" src="/images/WGC_gold_ball.png" alt="" />
		}
		else if (placement === 2) {
			return <img className="medal" src="/images/WGC_silver_ball.png" alt="" />
		}
		else if (placement === 3) {
			return <img className="medal" src="/images/WGC_bronze_ball.png" alt="" />
		}
		else {
			return <>
				<span className="stat-number desktop-items">{'#' + (placement)}</span>
				<span className="stat-number mobile-items">{(placement)}</span>
			</>
		}
	}
	else if (error || challengeError) {
		return <span className="stat-number">-</span>;
	}
	else {
		return <>
			<span className="stat-number desktop-items">{'#' + (index + 1)}</span>
			<span className="stat-number mobile-items">{(index + 1)}</span>
		</>
	}

}

const showImageAndName = ({ participant }) => {
	return <>
		<img className="profile-picture" src={typeof participant.profilePictureUrl === 'undefined' ? '/images/profile-picture.png' : participant.profilePictureUrl} alt="Profile" />
		{participant.isInfluenser ?
			<div className="twitch-partner">
				<img src="/images/twitch-icon.svg" alt="Twitch Partner" />
				{participant.firstName}
			</div> : participant.firstName + ' ' + participant.lastName
		}
		</>
}

const showScoreAndPayout = ({ participant }) => {
	return <>
		{ showScore({ strokes: participant.strokes, points: participant.points }) }
		{showPayout({ payoutType: participant.payoutType, payout: participant.payout, merchandise: participant.merchandise })}
	</>
}

const showFinishedTop = ({ finishedTop25, finishedTop10, finishedTop1 }) => {

	if (typeof finishedTop1 !== 'undefined' && finishedTop1) {
		return ' Won game!';
	}
	else if (typeof finishedTop10 !== 'undefined' && finishedTop10) {
		return ' Finished top 10!';
	}
	else if (typeof finishedTop25 !== 'undefined' && finishedTop25) {
		return ' Finished top 25!';
	}
	else if (typeof finishedTop1 !== 'undefined' && typeof finishedTop10 !== 'undefined' && typeof finishedTop25 !== 'undefined' && !finishedTop1 && !finishedTop10 && !finishedTop25) {
		return ' Died early';
	}
	else {
		return '';
	}

}


const showPayout = ({ payoutType, payout, merchandise }) => {
	if (typeof payoutType === 'undefined')
		return '';

	else if (payoutType === PayoutType.CASH) {
		return (

			typeof payout !== 'undefined' && payout !== null && payout > 0 ? <div className="winnings">${payout}</div> : ''
		);
	}
	else if (payoutType === PayoutType.MERCHANDISE) {
		return (

			typeof merchandise !== 'undefined' && merchandise !== null ? <div className="winnings">{merchandise}</div> : ''
		);
	}
	else {
		return '';
	}
}
